module.exports = __webpack_public_path__ + "static/img/background.6c603a3e.svg";